// import React from "react";
// import { Link, useLocation } from "react-router-dom";

// const PromotedProductsGrid = ({
//   products = [],
//   t,
//   isArabic,
//   getDiscountedPrice,
// }) => {
//   const location = useLocation();

//   if (!products || products.length === 0) return null;

//   return (
//     <div className="mb-5">
//       <div className="d-flex align-items-center mb-3">
//         <h4
//           style={{
//             fontWeight: 700,
//             marginBottom: 0,
//           }}
//         >
//           Sponsored Products
//         </h4>
//       </div>

//       <div className="row g-4">
//         {products.map((p, i) => {
//           const offer = p.offer_type
//             ? {
//               offer_type: p.offer_type,
//               discount_percentage: p.discount_percentage,
//               flat_amount: p.flat_amount,
//               buy_quantity: p.buy_quantity,
//               get_quantity: p.get_quantity,
//             }
//             : null;

//           const originalPrice = Number(
//             String(p.price_numeric || p.price || 0).replace(/[^\d.]/g, "")
//           );

//           const finalPrice = getDiscountedPrice(
//             originalPrice,
//             offer
//           );

//           return (
//             <div
//               key={`${p.id || p.product_id}-${i}`}
//               className={
//                 products.length === 1
//                   ? "col-lg-12"
//                   : products.length === 2
//                     ? "col-lg-6 col-md-6"
//                     : "col-lg-4 col-md-6"
//               }
//             >
//               <div
//                 className="product_card"
//                 style={{
//                   border: "2px solid #f3c400",
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: 10,
//                     right: 10,
//                     zIndex: 5,
//                     background: "#f3c400",
//                     color: "#000",
//                     fontWeight: 700,
//                     fontSize: 12,
//                     padding: "4px 8px",
//                     borderRadius: 4,
//                   }}
//                 >
//                   Sponsored
//                 </div>

//                 <div className="product_img">
//                   <img
//                     src={
//                       p.image && p.image.trim() !== ""
//                         ? p.image.startsWith("http")
//                           ? p.image
//                           : `http://192.168.2.17:5000/${p.image}`
//                         : p.img1 && p.img1.trim() !== ""
//                           ? p.img1.startsWith("http")
//                             ? p.img1
//                             : `http://192.168.2.17:5000/${p.img1}`/
//                           : null
//                     }
//                     alt={isArabic ? p.name_ar || p.name : p.name}
//                     onError={(e) => {
//                       e.target.style.display = "none";
//                     }}
//                   />
//                 </div>

//                 <div className="product_text">
//                   <h4 className="product_title">
//                     {isArabic
//                       ? p.name_ar || p.name
//                       : p.name}
//                   </h4>

//                   <div
//                     style={{
//                       marginBottom: 10,
//                       color: "#ff9900",
//                       fontSize: 14,
//                     }}
//                   >
//                     ★★★★☆ (4.5)
//                   </div>

//                   <p className="product_price">

//                     {offer &&
//                       finalPrice < originalPrice ? (
//                       <>
//                         <span>
//                           {t("qar")} {finalPrice.toFixed(2)}
//                         </span>

//                         <del
//                           style={{
//                             marginLeft: 8,
//                             color: "#999"
//                           }}
//                         >
//                           {t("qar")} {originalPrice.toFixed(2)}
//                         </del>
//                       </>
//                     ) : (
//                       <span>
//                         {t("qar")} {originalPrice.toFixed(2)}
//                       </span>
//                     )}
//                   </p>

//                   {p.description && (
//                     <p
//                       style={{
//                         fontSize: 13,
//                         minHeight: 40,
//                       }}
//                     >
//                       {String(p.description).slice(
//                         0,
//                         80
//                       )}
//                     </p>
//                   )}

//                   <div className="product_actions">
//                     <Link
//                       to={`/ShopDetails/${p.id || p.product_id
//                         }${location.search}`}
//                       className="add_cart_btn"
//                     >
//                       {t("viewProduct")}
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <hr style={{ marginTop: 30 }} />
//     </div>
//   );
// };

// export default PromotedProductsGrid;









import React from "react";
import { Link, useLocation } from "react-router-dom";


const PromotedProductsGrid = ({
  products = [],
  t,
  isArabic,
  getDiscountedPrice,
}) => {
  const location = useLocation();

  if (!products || products.length === 0) return null;

  return (
    <div className="pp-wrapper mb-5">
      <div className="pp-heading-row">
        <div>
          <h4 className="pp-heading">Sponsored Products</h4>
          <div className="pp-subtext">
            Top promoted items in this category
          </div>
        </div>
      </div>

      <div className="pp-row">
        {products.map((p, i) => {
          const offer = p.offer_type
            ? {
                offer_type: p.offer_type,
                discount_percentage: p.discount_percentage,
                flat_amount: p.flat_amount,
                buy_quantity: p.buy_quantity,
                get_quantity: p.get_quantity,
              }
            : null;

          const originalPrice = Number(
            String(p.price_numeric || p.price || 0).replace(/[^\d.]/g, "")
          );

          const finalPrice = getDiscountedPrice(originalPrice, offer);

          const productImage =
            p.image && p.image.trim() !== ""
              ? p.image.startsWith("http")
                ? p.image
                : `http://192.168.2.17:5000/${p.image}`
              : p.img1 && p.img1.trim() !== ""
              ? p.img1.startsWith("http")
                ? p.img1
                : `http://192.168.2.17:5000/${p.img1}`
              : null;

          return (
            <div
              key={`${p.id || p.product_id}-${i}`}
              className="pp-card"
            >
              <div className="pp-badge">
                Sponsored
              </div>

              <div className="pp-image-side">
                {productImage ? (
                  <img
                    src={productImage}
                    alt={isArabic ? p.name_ar || p.name : p.name}
                    className="pp-image"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : null}
              </div>

              <div className="pp-content">
                <div>
                  <h5 className="pp-title">
                    {isArabic ? p.name_ar || p.name : p.name}
                  </h5>

                  <div className="pp-rating">
                    ★★★★☆
                    <span className="pp-rating-count">
                      (4.5)
                    </span>
                  </div>

                  <div className="pp-price-wrap">
                    {offer && finalPrice < originalPrice ? (
                      <>
                        <div className="pp-price">
                          {t("qar")} {finalPrice.toFixed(2)}
                        </div>

                        <div className="pp-original">
                          M.R.P.
                          <del>
                            {" "}
                            {t("qar")}{" "}
                            {originalPrice.toFixed(2)}
                          </del>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="pp-price">
                          {t("qar")}{" "}
                          {originalPrice.toFixed(2)}
                        </div>

                        <div className="pp-original">
                          M.R.P.
                        </div>
                      </>
                    )}
                  </div>

                  {p.description && (
                    <div className="pp-desc">
                      {String(p.description).slice(0, 80)}
                    </div>
                  )}

                  <div className="pp-verified">
                    ✔ Verified
                  </div>
                </div>

                <div className="pp-actions">
                  <Link
                    to={`/ShopDetails/${p.id || p.product_id}${location.search}`}
                    className="pp-button"
                  >
                    {t("viewProduct")}
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <hr className="pp-divider" />
    </div>
  );
};

export default PromotedProductsGrid;